// Client-side mirror of backend/utils/price.js getDiscountedPrice, used only to
// pre-fill the take-order wizard so what the admin sees matches what checkout
// charges. The server recomputes authoritatively via applyCustomerPrices.
//
// customPrice shape (from GET /admin/users/:userId/customer-prices):
//   { variant_id, price, pricing_model, volume_type, volume_threshold,
//     post_threshold_price, past_qty, past_weight }
// variant shape: { price, weight_value, weight_unit }
import { toKilogramEquivalent } from './weightPieces';

export function effectiveCustomerPrice(variant, customPrice, qty) {
  if (!customPrice || !variant) return null;
  if (customPrice.pricing_model === 'volume') {
    const isQuantity = customPrice.volume_type === 'quantity';
    const pastVolume = isQuantity
      ? Number(customPrice.past_qty) || 0
      : Number(customPrice.past_weight) || 0;
    const weightValue = variant.weight_value != null ? (toKilogramEquivalent(variant.weight_value, variant.weight_unit) || 0) : 0;
    // Magnitude: a refund line (negative qty) resolves the price of what it
    // refunds, it does not demote the customer's volume tier.
    const nQty = Math.abs(Number(qty) || 0);
    const addingVolume = isQuantity ? nQty : nQty * weightValue;
    const totalVolume = pastVolume + addingVolume;
    const threshold = Number(customPrice.volume_threshold) || 0;
    if (totalVolume >= threshold) {
      const post = parseFloat(customPrice.post_threshold_price);
      return Number.isNaN(post) ? Number(variant.price) : post;
    }
    return parseFloat(customPrice.price);
  }
  return parseFloat(customPrice.price);
}
